import { httpWrapper } from 'services/http';
import userService from 'services/user';
import { API_URL_CA_V2, ENDPOINT_CORPORATE_CLIENT_PLACEHOLDER } from 'constants.js';
import { endpoint } from '.';

const readByUserAccountId = async userAccountId => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'GET',
    url: endpoint(ENDPOINT_CORPORATE_CLIENT_PLACEHOLDER, false, API_URL_CA_V2),
    params: {
      userAccountId,
    },
    headers: {
      ...authHeaders,
    },
  };

  const response = httpWrapper(requestOptions);
  return response;
};

const corporateClientPlaceholders = {
  readByUserAccountId,
};

export default corporateClientPlaceholders;
